import React, { useState } from 'react';
import i18n from '../../locales/index';
import { Row, Col, Container,Image } from 'react-bootstrap'
import './index.css'
import TitleBold from '../Text/TitleBold';
import TitleLight from '../Text/TitleLight';
import MainStyles from '../../styles/MainStyles';
import BlueButtonOutlineDark from '../Buttons/BlueButtonOutlineDark';
import icon3 from '../../assets/images/icon3.svg'
import ModalDetails from '../ModalDetail';
import BlueButton from '../Buttons/BlueButton';
import { convertDate, formatNumber } from '../../services/utils'


const SerialReview = ({ nextRevisionDate, nextRevisionOdometer }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <Container fluid="md">
      <ModalDetails show={show} handleClose={handleClose}  guaranteeStamp
        image={<Image src={icon3} alt='tool' className='icon-ok' style={{marginTop:"-60px", marginLeft:"200px"}} />}
        text={
          <TitleLight
          ownClass={"modal-text"}
          text={i18n.t('serial_review.detail')}
          color={MainStyles.colors.black}
          size={'xsmall'} />
          }
        button={
          <BlueButton                
                text={"Ok, entendi"}
                isRounded={true}
                marginTop
                onClick={handleClose}
                
            /> 
        }
      />
   

      <Row className={'mainRow service-status-row'}>

        <Col md={{ span: 1 }} lg={1} xl={1} sm={1} xs={1}>
          <Image 
          src={ icon3 }           
          alt='tool' className='icon-ok' style={{marginTop:"-70px"}} /> 
        </Col>
        <Col md={{ span: 5 }} lg={4} xl={4} sm={4} xs={12}>
          <Row>
            <TitleBold
              text={i18n.t('serial_review.title')}
              color={MainStyles.colors.black}
              ownClass={'serial_review service_title'}
              size={'big'} />
          </Row>
          
          <Row>
            <TitleLight
              text={i18n.t('serial_review.description').replace("REVISOES", `3 revisões gratuitas`).replace("NEXTKM", formatNumber(nextRevisionOdometer)).replace("DATANEXTREVIEW", convertDate(nextRevisionDate.replace('00', '10'), true))}
              color={MainStyles.colors.black}
              size={'small'} />
          </Row>
            
          <Row>
            <BlueButtonOutlineDark
              text={"Ver detalhes"}
              isRounded={true}
              marginTop
              marginRight
              onClick={handleShow}
            /> 
            <BlueButtonOutlineDark
              text={"Agendar Servico"}
              isRounded={true}
              marginTop
              onClick={() => {
                window.open('https://vwapps.volkswagen.com.br/Servicebook', '_blank')
              }}
            />
          </Row>
          <br/>
        </Col>
    
      </Row>
    </Container>
  )
}

export default SerialReview
